// Controls who can see the Templates gallery (RGR-aligned lessons and any
// future curriculum-aligned catalogs). DEFAULT: hidden. Strict email allowlist —
// any teacher whose email isn't explicitly listed sees the access gate.
//
// To grant access to a new teacher, add their email (lowercase) to ALLOWED_EMAILS.

export const ALLOWED_EMAILS: string[] = [
  'danielstedman@gmail.com',
  'danny@joinpressto.com',
  'rgr-curriculum@joinpressto.com',
  'daniel@joinpressto.com',
  'daniel+2@joinpressto.com',
  'ds@jp.com',
];

export function hasTemplatesAccess(email: string | null | undefined): boolean {
  if (!email) return false;
  const lower = email.toLowerCase().trim();
  return ALLOWED_EMAILS.some((e) => e.toLowerCase() === lower);
}
